import script from "./ShopAreasDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ShopAreasDialog.vue?vue&type=script&setup=true&lang=js"

import "./ShopAreasDialog.vue?vue&type=style&index=0&id=7a7f2560&lang=css"
import "./ShopAreasDialog.vue?vue&type=style&index=1&id=7a7f2560&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a7f2560"]])

export default __exports__